import React from 'react';
import { Link } from 'react-router-dom';

const templates = [
  {
    to: '/freelance-contract-template',
    title: 'Freelance Contract Template',
    description: 'Professioneel freelance contract voor België en Nederland. Inclusief betalingsvoorwaarden en intellectueel eigendom.',
    icon: '📄',
  },
  {
    to: '/nda-template',
    title: 'NDA Template',
    description: 'Non-Disclosure Agreement voor freelancers. Bescherm vertrouwelijke informatie bij samenwerking.',
    icon: '🔒',
  },
  {
    to: '/consultancy-contract-template',
    title: 'Consultancy Contract Template',
    description: 'Consultancy overeenkomst voor zelfstandige adviseurs. Duidelijke afspraken over scope en vergoeding.',
    icon: '💼',
  },
  {
    to: '/algemene-voorwaarden-generator',
    title: 'Algemene Voorwaarden Generator',
    description: 'Genereer algemene voorwaarden voor jouw freelance onderneming. Juridisch correct en direct bruikbaar.',
    icon: '📋',
  },
  {
    to: '/freelance-contract-voorbeeld',
    title: 'Freelance Contract Voorbeeld',
    description: 'Gratis voorbeeld van een freelance contract. Gebruik als basis voor jouw eigen overeenkomst.',
    icon: '✏️',
  },
];

const TemplatesSection = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 pb-16">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold mb-2" style={{ color: '#2F4E6F' }}>
          Populaire Contract Templates
        </h2>
        <p className="text-muted-foreground text-base max-w-xl mx-auto">
          Gratis contract templates en juridische gidsen voor freelancers in België en Nederland.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {templates?.map((tpl) => (
          <Link
            key={tpl?.to}
            to={tpl?.to}
            className="group bg-white rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md hover:border-orange-300 transition-all duration-200 flex flex-col gap-3"
          >
            <div className="text-3xl">{tpl?.icon}</div>
            <h3
              className="text-base font-semibold group-hover:text-orange-500 transition-colors"
              style={{ color: '#2F4E6F' }}
            >
              {tpl?.title}
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed flex-1">
              {tpl?.description}
            </p>
            <span
              className="text-sm font-medium mt-1"
              style={{ color: '#FF8C00' }}
            >
              Bekijk template →
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default TemplatesSection;
